import { Button } from "@mui/material";
import type { FC } from "react";

interface Props {
  readonly onClick: () => void;
}

const ReturnToPasswordLoginButton: FC<Props> = ({ onClick }) => (
  <Button variant="text" color="primary" onClick={onClick} sx={{ fontWeight: 600, textTransform: "none", margin: 2 }}>
    Wróć do logowania z hasłem
  </Button>
);

export default ReturnToPasswordLoginButton;
